/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

// Redux Store
import { get, isArray } from "lodash";

import Form from "../Form";
import { comma } from "../../utils/number";
import { editCompanyManagerInfo } from "../../apis/admin/companies";
import systemAlert from "../../utils/systemAlert";
import useForm from "../../hooks/useForm";
const CareCompanyInfo = ({ company, managerCompany, cancel }) => {
  // const [mode, setMode] = useState('detail')

  const [fields] = useState([
    {
      type: 'title',
      title: '기본정보'
    },
    [
      {
        title: "사업자등록번호", label: "-", key: "comNum",
        // type: "input",
        // options: { disabled: mode === "detail" },
      },
      {
        title: "법인 등록번호",
        key: "rgeNum",
        // type: "input",
        // options: { disabled: mode === "detail" },
      },
    ],
    [
      {
        title: "대표자명",
        label: "-",
        key: "ceoName",
        // type: "input",
        // options: { disabled: mode === "detail" },
      },
      {
        title: "직원수",
        label: "-",
        key: "employees",
        onValue: (value, field, data) => {
          return (
            <>
              {comma(get(value, 'length', 0))} 명
            </>
          );
        },
      },
    ],
    {
      type: 'title',
      title: '수임정보'
    },
    [
      {
        title: "수임일",
        key: "startTime",
        type: "datepicker",
        required: false,
      },
      {
        title: "수임종료일",
        key: "endTime",
        type: "datepicker",
        required: false,
      },
    ],
    [
      {
        title: "참조파일",
        titlestyle: { fontSize: '18px', marginTop: '12px' },
        key: "fileIdxes",
        type: "dropzone",
        required: false,
        fullWidth: true
      },
    ],
    [
      {
        title: "메모",
        titlestyle: { fontSize: '18px', marginTop: '12px' },
        key: "memo",
        type: "textarea",
        required: false,
        fullWidth: true
      },
    ],
  ]);

  const _submit = ({ name, startTime, endTime, fileIdxes, memo, ...form }) => {

    const _form = {
      ...(isArray(fileIdxes) && { fileIdxes }),
      ...(memo && { memo }),
      ...(isArray(startTime) && { startTime: startTime[0] + ' 00:00:00' }),
      ...(isArray(endTime) && { endTime: endTime[0] + ' 00:00:00' }),
    }
    systemAlert(`'${name}'회사의 수임정보를 수정하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '확인',
          onClick: () => {


            editCompanyManagerInfo(
              managerCompany.companyIdx,
              company.companyIdx,
              _form
            )
              .then(() => {
                systemAlert('수임정보가 수정 되었습니다.')
              })
              .catch(() => {
                systemAlert('수임정보 수정 실패 헀습니다.')
              })
          }
        }
      ]
    })
  };


  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    // originForm,
    // setOriginForm,
    // setValidateFields,
  } = useForm(
    company,
    _submit,
  );

  return (
    <>
      {/* <ColCard size="sm">
        <Row className="form-row">
          <Col className="form-col" sm={12}> */}
      <Form
        isRequiredShow={true}
        fields={fields}

        form={form}
        errors={errors}
        setForm={setForm}
        onChange={handleOnChange}
        submitText={'수정'}
        submit={handleSubmit}
        cancel={cancel}
      />
      {/* </Col>
        </Row>
      </ColCard> */}
    </>
  );
};

export default CareCompanyInfo;
